import x, { css } from '@xstyled/styled-components'

export const RichTextWrapper = x.div`
${({ theme }) => css`
    font-weight: ${theme.fontWeights[5]};
    padding: ${theme.space[3]}px;

    p {
      font-size: ${theme.fontSizes[6]}px; 
      line-height: 1.5;

      ${theme.mediaQueries.aboveMobile} {
        font-size: ${theme.fontSizes[5]}px;  
        line-height: 1.75;
      }
    }

    ${theme.mediaQueries.aboveMobile} {
      padding: ${theme.space[5]}px; 
    }
  `}
`
